import { GlucoseUnit } from "@tandemdiabetes/sugarmate-api-react-client"
import { useAccountProperty } from "./useAccountProperty"

export function useGlucoseUnit() {
  return useAccountProperty(
    "units",
    GlucoseUnit.MilligramsPerDeciliter,
  )
}
